import * as React from 'react';
import { Chip } from '@material-ui/core';

interface TableCellChipProps {
  icon?: React.ReactElement;
  label: string;
  backgroundColor: string;
  fontColor: string;
}

const TableCellChip: React.FC<TableCellChipProps> = ({
  icon, label, backgroundColor, fontColor,
}) => (
  <Chip
    icon={icon}
    label={label}
    style={{
      backgroundColor, color: fontColor, borderRadius: 5, fontSize: 12,
    }}
  />
);

export default TableCellChip;
